package music.jammers.client.shared.component.member.info.legend.presentation.viewmodel

import music.jammers.client.shared.component.BaseViewModel
import music.limasoul.client.shared.navigation.Router

class MemberInfoDialogViewModel(
    private val router: Router,
) : BaseViewModel() {

    fun onDismissClicked() {
        router.back()
    }
}